import React from "react";

import FurtherReadingByline from "./further-reading-byline";

class FurtherReadingListArticleItem extends React.Component {
  volumeAndIssue() {
    if (this.props.item.data.Volume && this.props.item.data.Number) {
      return ` ${this.props.item.data.Volume}(${this.props.item.data.Number})`;
    } else if (this.props.item.data.Volume) { 
      return ` ${this.props.item.data.Volume}`;
    } else if (this.props.item.data.Number) {
      return ` ${this.props.item.data.Number}`;
    }

    return null;
  }

  render() {
    return (
      <li className="further-reading__list-item">
        <div className="further-reading__details">
          <div className="further-reading__title">
            {(this.props.item.data.URL) ? (
              <a href={this.props.item.data.URL}>{this.props.item.data.Title}</a>
            ) : this.props.item.data.Title}
          </div>
          <FurtherReadingByline
            author={this.props.item.data.Author}
            editor={this.props.item.data.Editor}
            translator={this.props.item.data.Translator}
          />

          {(this.props.item.data.Description) ? (
            <p>
              {this.props.item.data.Description}
            </p>
          ) : null}

          <div className="further-reading__containing-volume">
            in{' '}
            {(this.props.item.data.Journal) ? (<i>{this.props.item.data.Journal}</i>) : null}{' '}
            {(this.props.item.data.Year) ? this.props.item.data.Year : null}
            {this.volumeAndIssue()}
            {(this.props.item.data.Pages) ? `: ${this.props.item.data.Pages}` : null}
          </div>
        </div>
      </li>
    );
  }
}

export default FurtherReadingListArticleItem;